var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGrad",
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D17713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5F0AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "coinClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#coinClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#goldGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.69,
    y: 1.69,
    width: 8.61,
    height: 8.61,
    fill: "url(#goldGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.69,
    y: 1.69,
    width: 8.61,
    height: 8.61,
    fill: "none",
    stroke: "rgba(245,240,175,0.65)",
    strokeWidth: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.19,
    y: 4.02,
    width: 5.61,
    height: 4.03,
    fill: "#F2E4A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6.04,
    width: 3.33,
    height: 4.94,
    fill: "none",
    stroke: "#F1E39F",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.33,
    y: 0.67,
    width: 2.67,
    height: 0.71,
    fill: "none",
    stroke: "#F0E09B",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.52,
    y: 2.02,
    width: 0.93,
    height: 1.09,
    fill: "none",
    stroke: "#F0E09B",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.67,
    y: 6,
    width: 0.65,
    height: 2.55,
    fill: "none",
    stroke: "#F0E09B",
    strokeWidth: 0.45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCoin);
export default __webpack_public_path__ + "static/media/credit-coin.5eca8cb35032e00807ef22be5ec3dc2e.svg";
export { ForwardRef as ReactComponent };